import { render, staticRenderFns } from "./Notificação.vue?vue&type=template&id=27b0c584&scoped=true"
import script from "./Notificação.vue?vue&type=script&lang=js"
export * from "./Notificação.vue?vue&type=script&lang=js"
import style0 from "./Notificação.vue?vue&type=style&index=0&id=27b0c584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0c584",
  null
  
)

export default component.exports